import styled from 'styled-components';
import { colors } from 'theme/colors';
import { Image as ImageChakra } from '@chakra-ui/react';

export const Container = styled.table`
  width: 100%;
`;

export const Head = styled.thead`
  width: 100%;

  tr {
    height: 3rem;
    width: 97.5%;
    text-align: left;
    line-height: 3rem;
    box-shadow: none;
    margin: 0;
    border: none !important;
    &:hover {
      border: none !important;
      text-decoration: none;
    }
  }
`;

export const Th = styled.th`
  width: 100%;
  font-size: 0.75rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.gray600};
  text-align: center;
  /* border: 1px solid blue; */

  &:first-child {
    text-align: start;
  }
`;

export const TableBody = styled.tbody`
  width: 100%;
  display: block;

  .containerFlex {
    position: relative;
  }

  .boxPopover {
    border: 2px solid ${({ theme }) => theme.colors.gray200};
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
    padding: 22px 0px;
    border-radius: 0.23rem;
    transition: 0.3s ease;
    background: #fff;

    &:hover {
      border: 2px solid ${colors.brand.primary};
    }
    svg {
      font-size: 20px;
    }
  }

  .cardEdit {
    background-color: ${colors.brand.primary};
    padding: 12px 30px;
    color: #fff;
    font-weight: 500;
    border-radius: 0.23rem;
    cursor: pointer;
  }

  .boxPopover:hover + .cardEdit {
    background-color: red;
  }

  .boxEdit {
    background-color: transparent !important;

    /* border: 1px solid red; */
    width: 7rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 1rem 0.5rem;
  }
`;

export const Td = styled.td`
  font-size: 0.8125rem;
  align-self: center;
`;

export const Tr = styled.tr<{ sizes: string }>`
  width: 100%;
  height: 3rem;
  padding-left: 1rem;
  padding-right: 2rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors[1500]};
  display: grid;
  justify-items: start;
  grid-template-columns: ${({ sizes }) => sizes};

  column-gap: 1rem;
  border: 2px solid ${colors.brand.gray200};
  border-radius: 4px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
  transition: 0.3s ease;
  user-select: none;
  -webkit-user-select: none;

  td {
    text-align: center;
    /* border: 1px solid red; */

    &:first-child {
      text-align: start;
    }

    &:nth-of-type(2) {
      margin-left: 0.5rem;
    }
    &:nth-of-type(3) {
      margin-left: 0.5rem;
    }
    &:nth-of-type(4) {
      margin-left: 0.5rem;
    }
    &:nth-of-type(5) {
      margin-left: 0.5rem;
    }
    &:nth-of-type(6) {
      margin-left: 0.5rem;
    }
    &:nth-of-type(7) {
      margin-left: 1rem;
    }
  }

  + tr {
    margin-top: 0.8rem;
  }

  &:hover {
    border: 2px solid ${colors.brand.primary};
  }

  td {
    width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    /* border: 1px solid red; */
    &:last-child {
      overflow: visible;
    }
  }
`;

export const Footer = styled.tfoot`
  margin-left: auto;
  display: inherit;
  margin-top: 1.5rem;
`;

export const Image = styled(ImageChakra)`
  padding: 0.9rem 0.5rem;
  border-radius: 0.23rem;
  margin-left: 8px;
  border: 2px solid ${colors.brand.gray200};
  cursor: pointer;
  transition: 0.2s ease;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);

  :hover {
    border: 2px solid ${colors.brand.primary};
  }
`;
